import {APIResponse} from "../services/HttpService";
import {ApiDefinition} from "./ApiDefinition";
import {UserDTO} from "./model/user/UserDTO";

class UserSettingsApiDefinition extends ApiDefinition{
    constructor() {
        super("/users/settings");
    }

    async userInfo(): Promise<APIResponse<UserDTO>> {
        return this.get();
    }

    // TODO: remove this
    async getLang(locale: string): Promise<APIResponse<any>> {
        return this.get(`lang-${locale}.json`);
    }
}

export const UserSettingsApi = new UserSettingsApiDefinition();